import React, {useState} from 'react';
import {Layout, Menu, Upload, Button, List, Divider, Typography, Row, Popconfirm} from "antd";
import {FolderOpenOutlined, LoadingOutlined, UploadOutlined, FileImageOutlined, CloseOutlined, DeleteOutlined} from "@ant-design/icons";
import {track} from "@amplitude/analytics-browser";
import {useTheme} from "./ThemeSwitching/use-theme";
import InfiniteScroll from "react-infinite-scroll-component";

const { Sider } = Layout;
const { Title, Text } = Typography;

const transformAssetsList = (assetsList, loaded) => {
    if (!loaded) {
        return [
            {
                key: "loading_assets",
                icon: React.createElement(LoadingOutlined),
                label: <div><LoadingOutlined style={{marginRight: 16}}/>Loading</div>
            }
        ]
    } else {
        if (!assetsList.length) {
            return [
                {
                    key: "no_assets",
                    icon: React.createElement(CloseOutlined),
                    label: "No assets"
                }
            ]
        } else {
            return assetsList.map((asset, j) => {
                return {
                    key: j,
                    label: asset.name
                };
            })
        }
    }
}

const AssetsMenuList = ({uploading, setUploading, loaded, assetsList, onSelectCallback, uploadProps, selectedIndex, onDeleteCallback}) => {
    const [uploadHidden, setUploadHidden] = useState(false);

    const [darkMode, setDarkMode] = useTheme();

    const textColor = darkMode ? "white" : "black";

    return (
        <Sider
            width={256}
            className="site-layout-background"
            style={{
                backgroundColor: darkMode ? "#1f1f1f" : "white",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                height: "100vh"
            }}
            collapsible
            onCollapse={(collapsed, type) => {
                setUploadHidden(collapsed);
            }}
        >
            <Upload {...uploadProps} >
                <Button
                    type="primary"
                    icon={<UploadOutlined />}
                    style={{margin: 16, borderRadius: 8}}
                    hidden={uploadHidden}
                    disabled={uploading}
                    loading={uploading}
                    onClick={() => {
                        track("upload_clicked");
                        setUploading(true);
                    }}
                >
                    Upload
                </Button>
            </Upload>
            <div style={{marginTop: 32}} hidden={uploadHidden}>
                <Row>
                    <FolderOpenOutlined style={{marginLeft: 24}}/>
                    <Title level={5} style={{marginLeft: 24}}>
                        Assets
                    </Title>
                </Row>

            </div>
            <div
                id="scrollableDiv"
                hidden={uploadHidden}
                style={{
                    height: "70vh",
                    overflow: 'auto',
                    padding: '0 16px',
                }}
            >
                <InfiniteScroll
                    dataLength={transformAssetsList(assetsList, loaded).length}
                    next={() => {}}
                    hasMore={false}
                    scrollableTarget="scrollableDiv"
                >
                    <List
                        dataSource={transformAssetsList(assetsList, loaded)}
                        renderItem={(item) => (
                            <List.Item
                                onClick={() => {
                                    let result = {
                                        ...item,
                                        url: assetsList[item.key].url,
                                        name: assetsList[item.key].name,
                                        path: assetsList[item.key].path,
                                        rtdb_asset_key: assetsList[item.key].rtdb_asset_key
                                    }

                                    if (assetsList[item.key].hasOwnProperty("default_prompt")) {
                                        result["default_prompt"] = assetsList[item.key].default_prompt
                                    }

                                    onSelectCallback(result)
                                }}
                                style={{
                                    textAlign: "left"
                                }}
                            >
                                <Text style={{color: item.key === selectedIndex ? "#1890FF" : textColor, maxWidth: 256, marginLeft: 8}}>
                                    {item.label}
                                </Text>
                                {
                                    item.key === "loading_assets"
                                        ? <div></div>
                                        : <Popconfirm
                                            title="Do you want to delete this asset?"
                                            okText="Yes"
                                            cancelText="No"
                                            onConfirm={(e) => {
                                                e.stopPropagation();
                                                onSelectCallback({});
                                                onDeleteCallback(assetsList[item.key].rtdb_asset_key);
                                                console.log("DELETE");
                                            }}
                                            onCancel={(e) => {
                                                e.stopPropagation();
                                                console.log("DELETION CANCEL");
                                            }}
                                        >
                                            <Button
                                                type="secondary"
                                                shape="circle"
                                                icon={<DeleteOutlined />}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            />
                                        </Popconfirm>
                                }
                            </List.Item>
                        )}
                    />
                </InfiniteScroll>
            </div>
        </Sider>
    );
};

export default AssetsMenuList;